import { render } from "./HomeView.vue?vue&type=template&id=b9813bc2"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\alvar\\OneDrive\\Kaggle\\Vue\\pro_vouchers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__